module.exports = __webpack_public_path__ + "static/media/bucket.0fe018fa.svg";